<template>
  <div class="px-5 py-4">
    <integration-page-header
      :title="$t('INTEGRATION_SETTINGS.WEBHOOK.PAGE_TITLE')"
      :description="$t('INTEGRATION_SETTINGS.WEBHOOK.PAGE_DESC')"
      :hint-title="$t('INTEGRATION_SETTINGS.WEBHOOK.HINT.TITLE')"
      :hint-description="$t('INTEGRATION_SETTINGS.WEBHOOK.HINT.DESC')"
    >
      <template #actions>
        <button-v2
          v-if="hasCreatePermission('Webhooks')"
          icon="add"
          @click="openAddPopup"
        >
          {{ $t('INTEGRATION_SETTINGS.WEBHOOK.HEADER_BTN_TXT') }}
        </button-v2>
      </template>
    </integration-page-header>

    <woot-loading-state
      v-if="uiFlags.fetchingList"
      class="mt-6"
      :message="$t('INTEGRATION_SETTINGS.WEBHOOK.LOADING')"
    />
    <p
      v-else-if="!records.length"
      class="mt-6 text-sm leading-5 text-gray-600 text-center"
    >
      {{ $t('INTEGRATION_SETTINGS.WEBHOOK.LIST.404') }}
    </p>
    <div v-else class="grid grid-cols-2 gap-4 mt-6">
      <webhook-card
        v-for="webHookItem in records"
        :key="webHookItem.id"
        :webhook="webHookItem"
        @edit="openEditPopup"
        @delete="openDeletePopup"
      />
    </div>

    <modal-v2 :show.sync="showAddPopup" :on-close="hideAddPopup">
      <new-webhook v-if="showAddPopup" :on-close="hideAddPopup" />
    </modal-v2>

    <modal-v2 :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-webhook
        v-if="showEditPopup"
        :id="selectedWebHook.id"
        :value="selectedWebHook"
        :on-close="hideEditPopup"
      />
    </modal-v2>

    <woot-delete-modal
      v2
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.TITLE')"
      :message="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.MESSAGE')"
      :message-value="deleteMessage"
      message-suffix="?"
      :confirm-text="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.BUTTON_TEXT')"
      :reject-text="$t('INTEGRATION_SETTINGS.WEBHOOK.FORM.CANCEL')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NewWebhook from './NewWebHook.vue';
import EditWebhook from './EditWebHook.vue';
import alertMixin from 'shared/mixins/alertMixin';
import WebhookCard from './WebhookCard.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import IntegrationPageHeader from '../OnlineCubedView/components/IntegrationPageHeader.vue';

export default {
  components: {
    NewWebhook,
    EditWebhook,
    IntegrationPageHeader,
    WebhookCard,
  },
  mixins: [alertMixin, hasPermissionMixin],
  data() {
    return {
      loading: {},
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedWebHook: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'webhooks/getWebhooks',
      uiFlags: 'webhooks/getUIFlags',
    }),
    deleteMessage() {
      return ` ${this.selectedWebHook.name || this.selectedWebHook.url}`;
    },
  },
  mounted() {
    this.$store.dispatch('webhooks/get');
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedWebHook = response;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    openEditPopup(webhook) {
      this.showEditPopup = true;
      this.selectedWebHook = webhook;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    confirmDeletion() {
      this.loading[this.selectedWebHook.id] = true;
      this.closeDeletePopup();
      this.deleteWebhook(this.selectedWebHook.id);
    },
    async deleteWebhook(id) {
      try {
        await this.$store.dispatch('webhooks/delete', id);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
